import React from 'react'
import styled from 'styled-components'
import typography from '../../../utils/typography'
import ContentVehicleMultiCardListing from '../../../components/ContentVehicleMultiCardListing/index'
import ContentSectionHeader from '../../../components/ContentSectionHeader/index'
import LinkRounded from '../../../components/LinkRounded'
import createModelNormaliser from '../../../../lib/model/model-to-vehicle-card-normaliser'
import { Flex } from 'rebass'

const Wrapper = styled.div`
  margin-bottom: ${typography.rhythm(1.5)};
`

const RangeCarouselWidget = ({ header, make, allModels }) => {
  if (Object.keys(make).length === 0 || !allModels) return null
  const normaliseModelForVehicleCard = createModelNormaliser(make, allModels)
  const vehicles = allModels
    .filter((model) => model.make === make.id && !model.parentModel)
    .map(normaliseModelForVehicleCard)

  return (
    <Wrapper>
      <ContentSectionHeader title={header} fg="#1E4F67" />
      <ContentVehicleMultiCardListing
        vehicles={vehicles}
        max={4}
        loop
        buttons={false}
      />
      <Flex alignItems="center" justifyContent="center">
        <LinkRounded to={`/${make.slug}`}>SEE THE FULL RANGE</LinkRounded>
      </Flex>
    </Wrapper>
  )
}

export default RangeCarouselWidget
